import PaymentOptionsSelection from ".";

export default function PaymentOptionsSelectionExample() {
  const discountVoucherItems: any = [
    {
      id: "11c8e6d7-5807-4708-b837-a6f547f56ac3",
      serviceOfferingType: "CONSULTATIONS",
      usageStatus: "ACTIVE",
      availableFrom: "2025-08-01T13:38:24.664148+00:00",
      availableTo: "2028-08-01T13:38:20.449226+00:00",
      name: "Online Doctor Consultation",
      description: "Virtual consultations with qualified medical doctors",
      chargeCode: "ONLINE_DOCTOR_CONSULTATION",
      offeringId: "4f24e185-2534-47e9-ac67-95b179c5f4cf",
      linkedBenefitType: "Product",
      linkedBenefitName: "Unu As-You-Go",
      document: null,
      voucherDetails: {
        voucherId: "fd94dce2-9d83-43a4-81f9-c741f7fbf4c1",
        voucherCode: "PNEJ-8357-AXHE",
        expiryDate: "2028-08-01T13:38:20+00:00",
      },
      discountVoucherDetails: {
        voucherId: "a2569085-574b-4a30-a0aa-a7df483ed20d",
        voucherCode: "ZPBN-8458-HMMJ",
        expiryDate: "2028-08-01T13:29:32+00:00",
        discountAmount: 4900,
        amount: 20000,
        originalAmount: 24900,
        currencyCode: "ZAR",
      },
    },
    {
      id: "8eb4d784-7652-468c-a60a-564b299853a4",
      serviceOfferingType: "CONSULTATIONS",
      usageStatus: "ACTIVE",
      availableFrom: "2025-08-01T13:39:09.698343+00:00",
      availableTo: "2028-08-01T13:39:01.741795+00:00",
      name: "Online Doctor Consultation",
      description: "Virtual consultations with qualified medical doctors",
      chargeCode: "ONLINE_DOCTOR_CONSULTATION",
      offeringId: "4f24e185-2534-47e9-ac67-95b179c5f4cf",
      linkedBenefitType: "Product",
      linkedBenefitName: "Unu As-You-Go",
      document: null,
      voucherDetails: {
        voucherId: "81e9f3be-2151-4a3d-8ef8-65986e9a9485",
        voucherCode: "GHYJ-4599-NUDE",
        expiryDate: "2028-08-01T13:39:01+00:00",
      },
      discountVoucherDetails: {
        voucherId: "a2569085-574b-4a30-a0aa-a7df483ed20d",
        voucherCode: "ZPBN-8458-HMMJ",
        expiryDate: "2028-08-01T13:29:32+00:00",
        discountAmount: 4900,
        amount: 20000,
        originalAmount: 24900,
        currencyCode: "ZAR",
      },
    },
  ];

  return (
    <PaymentOptionsSelection
      isBuyCareCardVoucher={false}
      onCardPaymentButtonClick={() => console.log("Pay")}
      onOneVoucherButtonClick={() => console.log("Pay with One Voucher")}
      onBack={() => console.log("back")}
      onVoucherButtonClick={() => console.log("Voucher")}
      serviceOfferingUsageItems={[]}
      selectedService={{
        chargeCode: "ONLINE_DOCTOR_CONSULTATION",
        amount: "100.00",
      }}
      discountVouchers={discountVoucherItems}
      onDiscountVoucherSelected={(item: any) => console.log(item)}
    />
  );
}
